import {applyMiddleware, createStore} from "redux";
import thunk from "redux-thunk";
import {composeWithDevTools} from "redux-devtools-extension/developmentOnly";
import {userReducer} from "./reducers/user";
import {panelReducer} from "./reducers/panel";
import {persistStore, persistCombineReducers} from 'redux-persist';
import localForage from 'localforage';

const composeEnhancers = composeWithDevTools({});

const authPersistConfig = {
  key: 'ECCO_IND_AUTH',
  storage: localForage
};

const rootReducer = {user: userReducer, panel: panelReducer};

const authPersistedReducer = persistCombineReducers(authPersistConfig, rootReducer);

const store = createStore(
  authPersistedReducer,
  composeEnhancers(
    applyMiddleware(
      thunk
    )),
);

const persistor = persistStore(store);

export {
  store,
  persistor,
};

export default store;
